module.exports = __webpack_public_path__ + "img/header-wave.8bc1e6da.png";